import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-deep px-5 py-14 sm:px-8 sm:py-20" data-id="element-68" data-mp="1laz9t6d953bs">
      <div className="mx-auto max-w-2xl" data-id="element-69" data-mp="1gcpgl1b38cst">
        <h2 className="text-center font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-70" data-mp="1ge0gur5br2f6">
          Preguntas Frecuentes
        </h2>
        <div className="mt-9 space-y-3" data-id="element-71" data-mp="2dyd8b8wlm6y0">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-plum/10 bg-cream" data-id="element-72" data-mp="2418m592r6bh7" data-mpi={index}>
                <h3 data-id="element-73" data-mp="1z5jm74mtmskd">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-terracotta" data-id="element-74" data-mp="snmm2svcupgw">
                    <span className="font-sans text-sm font-bold text-plum sm:text-base" data-id="element-75" data-mp="khtg5gotkixc">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-terracotta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-76" data-mp="bi6i94vatv91" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5" data-id="element-77" data-mp="3jyrtksbel0fb">
                    <p className="font-sans text-sm leading-relaxed text-plum-soft sm:text-base" data-id="element-78" data-mp="3nyigum1q0yf3">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}